import React from "react";
import { Leaf } from "lucide-react";

/**
 * The Root Forum brand mark.
 * Cream circle + hand-drawn green leaf + serif wordmark.
 * Used in both the public navbar and the admin/practitioner layout.
 *
 * Props:
 *  - size: "sm" | "md" | "lg"  (controls leaf badge + text size)
 *  - theme: "light" | "dark"   (text color — dark text on light bg, vice versa)
 */
export default function Logo({ size = "md", theme = "light", className = "" }) {
  const sizes = {
    sm: { badge: "w-7 h-7", icon: "w-3.5 h-3.5", text: "text-base" },
    md: { badge: "w-9 h-9", icon: "w-[18px] h-[18px]", text: "text-[1.35rem]" },
    lg: { badge: "w-11 h-11", icon: "w-5 h-5", text: "text-[1.55rem]" },
  };
  const s = sizes[size] || sizes.md;
  const textColor = theme === "dark" ? "text-tf-cream-50" : "text-tf-ink";
  const badgeBg = theme === "dark" ? "bg-tf-cream-100/95" : "bg-tf-cream-100";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="The Root Forum">
      <span className={`${s.badge} rounded-full ${badgeBg} flex items-center justify-center shrink-0`}>
        <Leaf className={`${s.icon} text-tf-green-800`} strokeWidth={1.6} />
      </span>
      <span className={`font-serif ${s.text} tracking-tight leading-none ${textColor}`}>
        The Root Forum
      </span>
    </span>
  );
}
